import { Table } from "@mantine/core";
import { gwpFields } from "src/pages/Settings/YachtSetup/Fgas/Fgas.utils";

import styles from "../YachtSetUp.module.scss";

interface Props {
  withActions?: boolean;
}

const nameFields = gwpFields.slice(0, 3);
const tonneFields = gwpFields.slice(3);

const FgasGwpTableHead = ({ withActions = false }: Props) => (
  <Table.Thead className={styles.stickyTableHead}>
    <Table.Tr>
      {nameFields.map(field => (
        <Table.Th key={field.name} rowSpan={2}>
          {field.label}
        </Table.Th>
      ))}
      <Table.Th colSpan={tonneFields.length} ta="center">
        Tonnes CO
        <sub style={{ fontSize: "0.5em" }}>2</sub>e
      </Table.Th>
      {withActions && <Table.Th rowSpan={2} w={50} />}
    </Table.Tr>
    <Table.Tr>
      {tonneFields.map(field => (
        <Table.Th key={field.name} ta="center">
          {field.label}
        </Table.Th>
      ))}
    </Table.Tr>
  </Table.Thead>
);

export default FgasGwpTableHead;
